"use client";

import Link from "next/link";
import messages from "@/messages/en.json";

const t = messages.errors.serverError;

interface ErrorPageProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function ErrorPage({ reset }: ErrorPageProps) {
  return (
    <main id="main-content" tabIndex={-1} className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <p className="text-8xl font-bold text-tap-border mb-6" aria-hidden="true">
          500
        </p>
        <h1 className="text-2xl font-bold text-tap-heading mb-3">{t.heading}</h1>
        <p className="text-tap-muted mb-8">{t.description}</p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={reset}
            className="inline-flex items-center justify-center px-6 py-3 rounded-full text-sm font-semibold bg-tap-cta text-tap-cta-text hover:opacity-90 transition-opacity"
          >
            {t.retry}
          </button>
          <Link
            href="/"
            className="inline-flex items-center justify-center px-6 py-3 rounded-full text-sm font-semibold border border-tap-border text-tap-heading hover:bg-tap-border transition-colors"
          >
            {t.cta}
          </Link>
        </div>
      </div>
    </main>
  );
}
